import { forwardRef } from 'react';
import { Icon, type IconProps } from './Icon';

type SvgIconProps = Omit<IconProps, 'children'>;

export const ChevronDown = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} {...props}>
      <path d="m6 9 6 6 6-6" />
    </Icon>
  ),
);
ChevronDown.displayName = 'ChevronDown';

export const ChevronRight = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} {...props}>
      <path d="m9 18 6-6-6-6" />
    </Icon>
  ),
);
ChevronRight.displayName = 'ChevronRight';

export const Close = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M18 6 6 18M6 6l12 12" />
  </Icon>
));
Close.displayName = 'Close';

export const Search = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </Icon>
));
Search.displayName = 'Search';

export const Plus = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M12 5v14M5 12h14" />
  </Icon>
));
Plus.displayName = 'Plus';

export const Minus = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M5 12h14" />
  </Icon>
));
Minus.displayName = 'Minus';

export const Check = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M20 6 9 17l-5-5" />
  </Icon>
));
Check.displayName = 'Check';

export const Warning = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01" />
  </Icon>
));
Warning.displayName = 'Warning';

export const Info = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 16v-4M12 8h.01" />
  </Icon>
));
Info.displayName = 'Info';

export const Edit = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
  </Icon>
));
Edit.displayName = 'Edit';

export const Trash = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
  </Icon>
));
Trash.displayName = 'Trash';

export const Copy = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </Icon>
));
Copy.displayName = 'Copy';

export const Calendar = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} {...props}>
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </Icon>
  ),
);
Calendar.displayName = 'Calendar';

export const Settings = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} {...props}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </Icon>
  ),
);
Settings.displayName = 'Settings';

export const User = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </Icon>
));
User.displayName = 'User';

export const Menu = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M4 12h16M4 6h16M4 18h16" />
  </Icon>
));
Menu.displayName = 'Menu';

export const ArrowLeft = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} {...props}>
      <path d="m12 19-7-7 7-7M19 12H5" />
    </Icon>
  ),
);
ArrowLeft.displayName = 'ArrowLeft';

export const ArrowRight = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} {...props}>
      <path d="m12 5 7 7-7 7M5 12h14" />
    </Icon>
  ),
);
ArrowRight.displayName = 'ArrowRight';

export const Refresh = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
  </Icon>
));
Refresh.displayName = 'Refresh';

export const Spinner = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
    className={`animate-spin ${props.className ?? ''}`}
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
      fill="none"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      stroke="none"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
    />
  </Icon>
));
Spinner.displayName = 'Spinner';

/**
 * Marcas dos provedores de login. Cores oficiais sem alteração (as diretrizes
 * de marca do Google e da Microsoft não permitem recolorir), por isso `fill`
 * fixo e sem `stroke`, ao contrário dos ícones de linha acima.
 */
export const GoogleLogo = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} stroke="none" {...props}>
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </Icon>
  ),
);
GoogleLogo.displayName = 'GoogleLogo';

export const MicrosoftLogo = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} stroke="none" viewBox="0 0 21 21" {...props}>
      <rect x="0" y="0" width="10" height="10" fill="#F25022" />
      <rect x="11" y="0" width="10" height="10" fill="#7FBA00" />
      <rect x="0" y="11" width="10" height="10" fill="#00A4EF" />
      <rect x="11" y="11" width="10" height="10" fill="#FFB900" />
    </Icon>
  ),
);
MicrosoftLogo.displayName = 'MicrosoftLogo';
